let getApi = () => import('@/services/Api');

const state = {
	actionDialog: false,
	transitionName: '',
	transitionHeaders: [],
	transitionParams: {},
	pageKey: 0
};

const getters = {
	getActionDialog: state => state.actionDialog,
	getTransitionName: state => state.transitionName,
	getTransitionHeader: state => state.transitionHeaders,
	getTransitionParams: state => state.transitionParams,
	getPageKey: (state) => state.pageKey
};
const actions = {
	storeActionDialog({commit}, payload) {
		commit('setActionDialog', payload.val);
	},
	storeTransitionName({commit}, payload) {
		commit('setTransitionName', payload.val);
	},
	async storeTransitionHeader({commit, getters, dispatch}, payload) {
		// if (!getters.getTransitionName) return;
		try {
			let {http} = await getApi({commit, getters});
			const response = await http.getData(`fsm/headers/${getters.getTransitionName}`, payload);
			const {headers = []} = response.data;
			let initItem = {}
			headers.forEach(function (field) {
				let key = field.value
				if(!initItem[key] || !initItem.hasOwnProperty(key)) {
					initItem[key] = field.default || '';
					if(field.type === 'REF') {
						initItem[key] = {
							id: field.default ? Number(field.default) : null,
							table: field.table,
							value: field.default
						};
					}
					if(field.type === 'ML') {
						initItem[key] = {table: field.table, kaz: '', rus: '', eng: ''};
					}
				}
			});
			commit('setMutated', initItem, {root: true});
			commit('setTransitionHeaders', headers);
			commit('setActionDialog', true);
			return headers
		} catch (e) {
			dispatch('storeError', e, {root: true});
		}
	},
	storeTransitionParams({commit}, payload) {
		commit('setTransitionParams', payload);
	},
	updateAssetPage({commit}){
		commit('incPageKey');
	},
	async processAsset({commit, getters,dispatch}) {
		let requestObject = {};
		let mutated = getters.getMutated
		getters.getTransitionHeader.forEach(header => {
			if(header.type === 'REF') {
				requestObject[header.init] = (mutated[header.value] || {}).id || null
			} else {
				requestObject[header.init] = mutated[header.value] ?? '';
			}
		});
		const {http} = await getApi();
		let response = await http.postData(`/fsm/makeTransition`, {
			nextTransition: getters.getTransitionName,
			transitionData: requestObject
		});
		if(response && response.status === 200) {
			commit('setDtiItemList', [], {root: true});
			commit('incPageKey');
			dispatch('refreshTableView',null, {root: true});
			commit('setActionDialog', false);
		}
	}
};
const mutations = {
	setActionDialog(state, val) {
		state.actionDialog = val
	},
	setTransitionName(state, val) {
		state.transitionName = val
	},
	setTransitionHeaders(state, val) {
		state.transitionHeaders = [...val]
	},
	setTransitionParams(state, val) {
		state.transitionParams = val
	},
	incPageKey: (state) => state.pageKey++

};

export default {
	state,
	getters,
	actions,
	mutations
}